import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import { OnyxEvent } from '../../models/event';
import { Payment } from '../../models/payment';
import { ErrorHandlerService } from '../../../shared/utils/error-handler.service';
import { TranslateService } from '@ngx-translate/core';
import { PaymentStatusUtils } from 'app/event/utils/payment-status-utils';

@Component({
  selector: 'pioneer-payment-record',
  templateUrl: './payment-record.component.html'
})
export class PaymentRecordComponent implements OnInit {

  @Input() latestPayment: Payment = null;

  onyxEvent: OnyxEvent;

  ui = {
    showRejectedMessage: false,
    strikeThroughPaymentLines: false
  };

  constructor(
    private errorHandlerService: ErrorHandlerService,
    private translateService: TranslateService
  ) {}

  @Input()
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  ngOnInit(): void {

    if (!this.onyxEvent) {
      this.errorHandlerService.throw(
        'Input property onyxEvent is null in PaymentRecordComponent',
        this.translateService.instant('MESSAGES.ERROR.INPUT_PROPERTY_NULL', {
          property: 'onyxEvent',
          className: 'PaymentRecordComponent'
        })
      );
    }

    if (!this.latestPayment) {
      this.errorHandlerService.throw(
        'Input property latestPayment is null in PaymentRecordComponent',
        this.translateService.instant('MESSAGES.ERROR.INPUT_PROPERTY_NULL', {
          property: 'latestPayment',
          className: 'PaymentRecordComponent'
        })
      );
    }

    const isError: boolean = PaymentStatusUtils.isError(this.latestPayment.status);
    if (isError) {
      this.ui.showRejectedMessage = true;
      this.ui.strikeThroughPaymentLines = true;
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/payment-record/payment-record.component.ts